export const RESET = 'LANGUAGE_LIST_RESET'
export const SET_ITEMS = 'LANGUAGE_LIST_SET_ITEMS'
export const SET_ERROR = 'LANGUAGE_LIST_SET_ERROR'
export const SET_VIEW = 'LANGUAGE_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'LANGUAGE_LIST_TOGGLE_LOADING'



// WEBPACK FOOTER //
// ./src/store/modules/language/list/mutation_types.js